<template>
  <KycDesktop
    :ratio="7/8"
    :next-button-theme="nextButtonTheme"
    :title="$t('kyc.titles.goal')"
    back-route="/kyc/desktop/knowledge"
    @next="next"
  >
    <div
      v-for="question in goalQuestions"
      :key="question.id"
      class="mb-4"
    >
      <BaseSmallTitle>{{ question.title }}</BaseSmallTitle>
      <Choice
        :multiple="question.multiple"
        :value="answer(question.id)"
        :question="question"
        class="mb-4"
        @input="changeChoice(question.id, $event)"
      />
    </div>
  </KycDesktop>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { find, some, isEmpty, isNil, isArray } from 'lodash';
import { SET_GOAL_ANSWER } from '../../../store/mutation-types';
import KycDesktop from '../Desktop.vue';
import Choice from '../Choice.vue';
import BaseSubtitle from '../../../components/BaseSubtitle.vue';
import BaseSmallTitle from '../../../components/BaseSmallTitle.vue';
import kyc from '../../../mixins/kyc';

export default {
  name: 'GoalQuestions',
  components: {
    KycDesktop,
    BaseSubtitle,
    BaseSmallTitle,
    Choice,
  },
  mixins: [kyc],
  computed: {
    ...mapState('kyc', ['goalQuestions', 'form']),
    nextButtonTheme() {
      const { goalAnswers } = this.form.attributes;
      if (goalAnswers && goalAnswers.length >= this.goalQuestions.length) {
        if (some(goalAnswers, answer =>
          isNil(answer.answer) ||
          (isArray(answer.answer) &&
          isEmpty(answer.answer)))
        ) {
          return 'disabled';
        }
        return 'primary';
      }
      return 'disabled';
    },
  },
  created() {
    this.fetchGoalQuestions();
  },
  methods: {
    answer(id) {
      const result = find(this.form.attributes.goalAnswers, { id });
      if (result && result.answer) {
        return result.answer;
      }
      return null;
    },
    ...mapActions('kyc', ['update', 'fetchGoalQuestions']),
    next() {
      this.update();
      this.$router.push('/kyc/desktop/attachments');
    },
    changeChoice(questionId, value) {
      this.$store.commit(`kyc/${SET_GOAL_ANSWER}`, {
        currentQuestionId: questionId,
        choice: value,
      });
    },
  },
};
</script>
